(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    function closeP1Menu(details, restoreFocus = false) {
  if (!details) return;
  details.open = false;
  if (restoreFocus) details.querySelector(':scope > summary')?.focus();
}
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const owner = event.target.closest('[data-p1-dropdown][open], [data-p1-mobile][open]');
  if (owner) { closeP1Menu(owner, true); event.stopPropagation(); }
});
document.addEventListener('click', event => {
  const closeButton = event.target.closest('[data-p1-close]');
  if (closeButton) closeP1Menu(closeButton.closest('[data-p1-mobile]'), true);
  document.querySelectorAll('[data-p1-dropdown][open], [data-p1-mobile][open]').forEach(details => {
    if (!details.contains(event.target)) closeP1Menu(details);
    else if (event.target.closest('a')) closeP1Menu(details);
  });
});
document.addEventListener('focusin', event => {
  document.querySelectorAll('[data-p1-dropdown][open], [data-p1-mobile][open]').forEach(details => {
    if (!details.contains(event.target)) closeP1Menu(details);
  });
});
document.addEventListener('pointerover', event => {
  if (event.pointerType !== 'mouse') return;
  const item = event.target.closest('[data-p1-sets]');
  if (item) item.querySelector('details').open = true;
});
document.addEventListener('pointerout', event => {
  if (event.pointerType !== 'mouse') return;
  const item = event.target.closest('[data-p1-sets]');
  if (item && !item.contains(event.relatedTarget) && !item.contains(document.activeElement)) closeP1Menu(item.querySelector('details'));
});
  } catch(e) { console.error(e); }
})();

})();
